import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from 'hooks/apollo';
import { Tooltip } from '@mui/material';
import { EXPORT_CHECKLISTS_LIST } from '../../mutations';
import { CHECKLIST_FILTERS_QUERY } from '../../queries';
import { buildExportDownloadUrl } from '../../../../../downloadList/api';
import { CloudDownload } from '@mui/icons-material';
import { fileType } from 'constants/fileTypes';
import { useSimpleError } from 'hooks/apolloWrappers';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from '@totalsoft/rocket-ui';
import { getOidcConfigName } from 'utils/functions';
import { useOidcAccessToken } from '@axa-fr/react-oidc';

const ExportAction = () => {
  const [t] = useTranslation();
  const showError = useSimpleError();
  const [filters, setFilters] = useState({});
  const { accessToken } = useOidcAccessToken(getOidcConfigName());

  const [exportAnchorEl, setShowHandleClose] = useState(null);
  const isExportOpen = Boolean(exportAnchorEl);

  const [exportChecklistList] = useMutation(EXPORT_CHECKLISTS_LIST, {
    onCompleted: async ({ exportChecklistList }) => {
      let downloadLink = null;
      try {
        downloadLink = await buildExportDownloadUrl(exportChecklistList.filePath, exportChecklistList.fileName, accessToken);
      } catch (error) {
        showError(error);
      }
      if (downloadLink) {
        window.location.href = downloadLink;
      }
    }
  });

  useQuery(CHECKLIST_FILTERS_QUERY, {
    onCompleted: data => {
      if (data)
        setFilters({
          documentName: data.checklistFilters.documentName.value,
          fullTextFilter: data.checklistFilters.fullTextFilter.value
        });
    }
  });

  const onExport = filters => {
    exportChecklistList({ variables: { filters } });
  };

  const handleExportClose = () => {
    setShowHandleClose(null);
  };

  const handleExportClick = event => {
    setShowHandleClose(event.currentTarget);
  };

  const handleExport = (fileType, filters) => () => {
    onExport({ ...filters, fileType });
    setShowHandleClose(null);
  };

  return (
    <>
      <Tooltip placement='top' title={t('Tooltips.DownloadChecklistList')}>
        <div>
          <IconButton color='primary' onClick={handleExportClick}>
            <CloudDownload />
          </IconButton>
          <Menu id='render-export-menu' anchorEl={exportAnchorEl} open={isExportOpen} onClose={handleExportClose}>
            <MenuItem onClick={handleExport(fileType.excel, filters)}>{t('Authorization.Excel')}</MenuItem>
            <MenuItem onClick={handleExport(fileType.csv, filters)}>{t('Authorization.CSV')}</MenuItem>
          </Menu>
        </div>
      </Tooltip>
    </>
  );
};

export default ExportAction;
